const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/orders`,
    customers: `${API_URL}/customers`
};

export default apiUrls;
